import {useEffect, useRef} from "react";
import {useFormikContext} from "formik";
import {isEqual} from "lodash";
import {ChecklistItem} from "@reside/reside-api-admission";

/**
 * Copies checklist items that changed on the server (e.g. a PCC document was uploaded for one of them)
 * into the form values, leaving every other value the user already entered untouched.
 *
 * Only items whose server version changed since the last sync are written, so a re-render with
 * an equal checklist does nothing.
 */
export const ChecklistItemsSync = ({
  checklist,
}: {
  checklist: ReadonlyArray<ChecklistItem>;
}): null => {
  const {setFieldValue} = useFormikContext();
  const syncedChecklist = useRef(checklist);

  useEffect(() => {
    const previousChecklist = syncedChecklist.current;
    syncedChecklist.current = checklist;

    checklist.forEach(checklistItem => {
      const previousItem = previousChecklist.find(
        ({id}) => id === checklistItem.id,
      );

      if (!isEqual(previousItem, checklistItem)) {
        setFieldValue(checklistItem.id, checklistItem);
      }
    });
  }, [checklist, setFieldValue]);

  return null;
};
